import { DefaultRequest } from 'scripts/api';

Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.Requests = function (entity, layoutNameSpace, screenName, action) {

    this.entity = entity;
    this.layoutNameSpace = layoutNameSpace || screenName;
    this.screenName = screenName;
    this.action = action;

    this.saveListSuccessCallback = (callbacks) => {
        if (callbacks && callbacks.afterSaveList) {
            callbacks.afterSaveList();
        } else {
            const router = App.Objects[this.entity];
            router.list();
        }
    };

    this.saveGridLayout = function (data, callbacks) {
        var pageLayout = null;
        var that = this;

        if (data && data.id) {
            const request = new DefaultRequest({
                url: "form/SearchGridLayout/UpdateColumns",
                method: 'post',
                data,
                success: function () {
                    pageLayout = new App.Collections.PageLayout();
                    pageLayout.setService(that.screenName);
                    pageLayout.setAction(that.action);
                    pageLayout.fetch({
                        success: function () {
                            const layout = pageLayout.first().attributes;
                            App.Forms[that.layoutNameSpace].layout[that.action] = layout;
                            that.saveListSuccessCallback(callbacks);
                        }
                    });
                }
            });
            request.send();
        } else {
            const customGridColumns = JSON.parse(localStorage.getItem('customGridColumns') || {});
            customGridColumns[this.layoutNameSpace] = {
                ...customGridColumns[this.layoutNameSpace],
                [Monet.Session.User.id]: data.searchGridColumns.sort((a, b) => a.columnOrder - b.columnOrder)
            };
            localStorage.setItem('customGridColumns', JSON.stringify(customGridColumns));

            if (!this.action || this.action === 'index') {
                const currentLayout = App.Forms[this.layoutNameSpace].layout.index;
                const searchGridActions = currentLayout?.sections[1]?.sectionRelatedLists[0]?.searchGridLayout?.searchGridActions;

                Monet.Grid.generateIndexLayout(
                    this.entity, 
                    currentLayout.userInterfaceAction.userInterface.description, 
                    {
                        customActions: searchGridActions || []
                    }
                );
            }
            this.saveListSuccessCallback(callbacks);
        }
    };
};
